import { Ping, PingResource } from './Ping'

export const transformToPing = (resource: PingResource): Ping => ({
    id: resource.id,
    type: resource.type,
    atom: resource.attributes.atom,
})
